import Event from '../../core/Event';
import { EstimationMonthSum } from '../../../domain/estimations/Estimations';
import Order, { OrderedSku, SumValues } from '../../../domain/Order';
import { LiabilityMet } from '../../../domain/isLiabilityMet';

export default class OrderCurrentReceived extends Event {
    public static type = 'OrderCurrentReceived';

    constructor(
        public readonly articlesEstimations: EstimationMonthSum,
        public readonly order: Order,
        public readonly orderedSku: OrderedSku,
        public readonly liabilityMet: LiabilityMet,
        public readonly orderedCheckout: SumValues,
        public readonly orderedStock: SumValues,
        public readonly estimated: SumValues
    ) {
        super(OrderCurrentReceived.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/order/events/OrderCurrentReceived.ts